import { render, staticRenderFns } from "./CertificateFile.vue?vue&type=template&id=aea794f2"
import script from "./CertificateFile.vue?vue&type=script&lang=js"
export * from "./CertificateFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports